import type { RowData } from '@tanstack/table-core';
import type { LinkProps } from 'next/dist/client/link';
import type React from 'react';

export enum View {
  Player = 'player',
  Club = 'club',
  Admin = 'admin',
}

export enum Cookies {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  LoggedUser = 'loggedUserId',
}

export type Nullable<T> = {
  [P in keyof T]: T[P] | null;
};

export type OptionItem<T> = T & { id: string | number };

export interface IClassName {
  className?: string;
}

declare module '@tanstack/react-table' {
  // eslint-disable-next-line unused-imports/no-unused-vars
  interface ColumnMeta<TData extends RowData, TValue> {
    className?: string;
    headerClassName?: string;
    cellClassName?: string | ((value: TData) => string | undefined);
    cellColSpan?: number | ((value: TData) => number | undefined);
    cellHidden?: boolean | ((value: TData) => boolean | undefined);
  }
}

export type NextLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps<any>> & LinkProps<any> & {
  children?: React.ReactNode | undefined;
} & React.RefAttributes<HTMLAnchorElement>;
